import script from "./InvoiceTemplateTable.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceTemplateTable.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceTemplateTable.vue?vue&type=style&index=0&id=7a04082f&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a04082f"]])

export default __exports__